import $ from 'jquery'
import kineSpecialties from './kine-specialties'
import ExcelModal from '@/views/parametres/import-excel-modal'
import ManageDureeBon from '@/views/parametres/configs/param-consultations/manage-duree-bon'
import AttributionAutomatique from './attribution-automatique/index.vue'
import listesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

export default {
    name: 'param-consultations',
    mixins: [kineSpecialties],
    components: {
        ExcelModal, ManageDureeBon, AttributionAutomatique
    },
    props: [],
    data() {
        return {
            fields: [
				'prestations',  { key: 'duree_bon', label: 'Durée de bon' }, 
                { key: 'actions', label: 'Action.s' }
			],
            // Page courante du catalogue (pagination et recherche côté serveur, données locales au composant)
            consultations: nouvelleListe(),
            // Liste complète, chargée à la demande (impression, durée de bon)
            consultations_completes: [],
            duree_loading: false,

            consul_loading: true,
            consul_empty: true,

            c_prestation: {
				type_consultation_id: 0,
                categorie_id: 2,
				libelle: '',
                duree_bon: ""
			},
            is_edit: false,

            save_loading: false,
            modal_title: 'Nouvelle prestation',
            exist_error: false,

            consult_to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            consultation_fields: {
                'Catégorie': 'categorie',
                'Libellé': 'libelle',
                'Moment de consultation': 'moment_consultation',
                'Prix': 'prix',
            },

            consultation_filename: 'Liste_Consultations.xls',
            state_toggler: 0,

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        list_consultations_with_tarif() {
            return this.$store.getters["list_consultations_with_tarif"];
        }
    },

    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        // Consultation généraliste
        this.fetchListeConsultations()
		
        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_de_consultations_'+tmpstamp
    },
    methods: {
        /**
         * Recherche côté serveur après la saisie (retour à la page 1)
         */
        rechercher(liste, charger) {
            rechercherDiffere(liste, charger)
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListConsultation'
            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeConsultations() {
            this.consul_loading = true
            this.can_view_percentage = true
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            if (this.consultations.total > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.fetchListeConsultations()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.fetchListeConsultations()
            this.c_refresh_timeout_id = setTimeout(() => {
                this.refreshListeConsultations()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeConsultations()
        },

        /**
         * Recharge la page courante du catalogue (après ajout, modification, suppression, import)
         */
        fetchListeConsultations() {
			return chargerPage(this.consultations, params => listesPaginees.typesConsultations(params)).then(() => {
                if (this.consultations.chargement) {
                    // Réponse périmée : une requête plus récente est en cours
                    return
                }

                // Catalogue vide (hors recherche) : message « Aucune donnée disponible »
                this.consul_empty = !this.consultations.erreur && this.consultations.total == 0 && this.consultations.q == ''

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.consul_loading = false
                    }
                } else {
                    this.consul_loading = false
                }
            });
		},

        /**
		 * Ajouter un type de prestation
		 */
		addPrestation () {
			this.is_edit = false
            this.modal_title = 'Nouvelle prestation'

			this.c_prestation = {
				type_consultation_id: 0,
                categorie_id: 2,
				libelle: '',
                duree_bon: '',
                unite_duree: 'jours'
			}
		},

        edit(data) {
            this.is_edit = true

            this.c_prestation = {
                type_consultation_id: data.id,
                categorie_id: data.categorie_id,
                libelle: data.nom,
                duree_bon: data.duree_bon,
                unite_duree: data.unite_duree
            }
            this.modal_title = data.nom
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.consult_to_be_deleted = {
                id: data.id,
                libelle: data.nom,
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTypeConsultation', this.consult_to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Type de consultation supprimé avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

					this.fetchListeConsultations(this.del_categorie_consultation);
					this.$refs.del_modal.click()

                    
                })
            }
        },

        /**
         * Enregistrer / Modifier une prestation
         */
        async submitPrestation() {
            const isValid = await this.$refs.consult_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            
            this.c_prestation.duree_bon = parseInt(this.c_prestation.duree_bon)
            
            this.$store.dispatch("saveTypeConsultation", this.c_prestation).then((response) => {
                this.save_loading = false

                if (response.success) {
                    this.successMsg('Opération effectuée avec succès')
                    this.fetchListeConsultations()

                    this.$refs.consult_form.reset()
                    this.$refs.modal_prestation.click()
                } else {
                    if (response.code == 409) {
                        this.exist_error = true
                    } else if (response.code == 500) {
                        this.errorToast('Merci de renseigner le nom du type de consultation')
                    } else if (response.code == 501) {
                        this.errorToast('Une erreur s\'est produite ! Merci de réessayer plustard')
                    }
                }
            })
        },

        clearError() {
            this.exist_error = false
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        handleBeforeGenerateConsultation() {
            let d = new Date()
            this.consultation_filename = 'Liste_Consultations_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        /**
         * Export Excel : la grille complète des tarifs de consultation est chargée au clic
         * (prop `fetch` de export-excel, appelée après before-generate)
         */
        fetchExportConsultations() {
            return this.$store.dispatch("getTarifsConsultations").then(() => {
                const lignes = this.list_consultations_with_tarif.map(consultation => ({
                    'categorie': (consultation.type_consultation.categorie_consultation_id == 1)?'Généraliste':'Spécialiste',
                    'libelle' : consultation.type_consultation.nom,
                    'moment_consultation': consultation.moment_consultation.denomination,
                    'prix' : (consultation.prix > 0)?consultation.prix:''
                }))

                if (lignes.length == 0) {
                    // Rien à exporter : export-excel s'arrête sans appeler before-finish
                    this.is_exporting = false
                }
                return lignes
            }).catch(() => {
                this.is_exporting = false
                this.errorToast("Impossible de préparer l'export. Merci de réessayer.")
                return []
            })
        },

        /**
         * Liste complète des types de consultation (impression, durée de bon)
         */
        chargerConsultationsCompletes() {
            return listesPaginees.typesConsultations().then((consultations) => {
                this.consultations_completes = consultations || []
                return this.consultations_completes
            })
        },

        setDureeBon() {
            if (this.duree_loading) {
                return
            }
            this.duree_loading = true

            this.chargerConsultationsCompletes().then(() => {
                this.state_toggler = (this.state_toggler == 0)?1:0

                $('.manage-duree-bon').modal('show')
            }).catch(() => {
                this.errorToast("Impossible de charger les consultations. Merci de réessayer.")
            }).finally(() => {
                this.duree_loading = false
            })
        },

        printConsultation() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            this.chargerConsultationsCompletes().then((consultations) => {
                const data = {
                    data_type: 'consultations',
                    prestations: consultations
                }
                this.$emit('emitTriggerPrint', data)
            }).catch(() => {
                this.errorToast("Impossible de charger la liste à imprimer. Merci de réessayer.")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}
